import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import BackspaceOutlinedIcon from "@material-ui/icons/BackspaceOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import moment from "moment";
import PropTypes from "prop-types";

import Confirm from "../../Confirm";
import DateSelector from "../../Shared/DateSelector";
import DefaultDataTable from "../../Shared/DefaultDataTable";
import Selector from "../../Shared/Selector";
import TabNavigationCtrlFilterPanel from "../../TabNavigationCtrlFilterPanel";
import { serverDate } from "../../../utils/date";
import { prettyDate } from "../../../utils/date";

import ModalData from "./modal-data";
import ModalDeleteRefuse from "./modal-delete-refuse";
import useStyles from "./styles";
import { getDataStorage, removeDataStorage, setDataStorage } from "../../../utils/filterManagementDataStore";

import { Checkbox} from "@material-ui/core";
import { parseISO } from "date-fns";

const getDataStorageBranch = () => getDataStorage('turn_config_checkSingleBranch');
const getDataStorageTurnDate = () => getDataStorage('turn_config_selectedTurnDate');

const TurnTabComponent = ({
   loadBlocks,
   blocks,
   branches,
   filter,
   setFilter,
   subRoutes,
   onDeleteItem,
   onAddItem,
   onUpdateItem,
   turnError,
   clearError,
   getNotificationsFromSchedConfigAsync
}) => {
   const classes = useStyles();
   
   const [deletingItem, setDeletingItem] = useState(null);
   const [editingItem, setEditingItem] = useState({});
   const [isOpenAddForm, setOpenAddForm] = useState(false);
   const [showAvailableTurn, setAvailableTurn] = useState(false);
   const [viewCheckbox, setViewCheckbox] = useState(!!getDataStorageBranch()?.value)

   const getTurnDate = () => {
      return (filter.turnDate || getDataStorage('turn_config_selectedTurnDate'));
   }

   useEffect(() => {
      const branchId = filter.turn_branch || getDataStorage('turn_config_checkSingleBranch')?.value;
      const turnDate = (filter.turnDate || getDataStorage('turn_config_selectedTurnDate'));

      if (branchId && !!turnDate && !showAvailableTurn) {
        const handleDate = moment(turnDate).format('YYYY-MM-DD');
        loadBlocks({
          branchId,
          date: handleDate,
          getAllTimeBlocks: showAvailableTurn
        });
      }
      if (branchId && showAvailableTurn) {
        removeDataStorage('turn_config_selectedTurnDate');
        loadBlocks({
          branchId,
          date: null,
          getAllTimeBlocks: showAvailableTurn
       });
      }
   }, [loadBlocks, showAvailableTurn, filter.turn_branch, filter.turnDate]);

   const isFilterDatePreviousThanToday = () => {
      return moment(new Date()).isAfter(getTurnDate(), 'day')
   }

   const isActionsDisabled = () => {
      return isFilterDatePreviousThanToday() || showAvailableTurn;
   }

   const ConfigButton = (item) => (
      <IconButton 
         data-cy={`edit-${item.id}`}
         id={`edit-${item.id}`}
         disabled={isActionsDisabled()} 
         onClick={() => 
         handleEditing(item)}
      >
         <SettingsOutlinedIcon />
      </IconButton>
   );

   const handleEditing = (item) => {
      setEditingItem({ ...item, start_date: filter.turnDate});
      setOpenAddForm(true);
   };

   const handleAddTurn = () => {
      setOpenAddForm(true);
   };

   const handleSaveData = (data) => {
      const blockData = {
         ...data,
         id_branch: filter.turn_branch ?? getDataStorageBranch()?.value,
         start_date: serverDate(filter.turnDate ?? getDataStorageTurnDate()),
         end_date: serverDate(data?.end_date) || null,
      };
      if (!blockData.id) {
         return onAddItem(blockData);
      }
      blockData.start_date = serverDate(data.start_date);
      return onUpdateItem(blockData);
   };

   const handleModalDeleteClose = (confirm) => {
      if (confirm) {
         onDeleteItem(deletingItem);
      }
      setDeletingItem(null);
   };

   const handleCloseDataModal = () => {
      setDeletingItem(null);
      setEditingItem({});
      setOpenAddForm(false);
   };

   const DeleteButton = (item) => (
      <IconButton
         data-cy={`delete-${item.id}`}
         id={`delete-${item.id}`}
         disabled={isActionsDisabled()}
         onClick={() => {
            setDeletingItem(item);
         }}
      >
         <BackspaceOutlinedIcon />
      </IconButton>
   );

   const handleBranchFilterChange = (selectedBranch) => {
     removeDataStorage('turn_config_selectedTurnDate');
     setDateSelected(null);
     filter.turnDate = null;
     setFilter({ ...filter, turn_branch: selectedBranch && selectedBranch.value });
   };

   const handleTurnDateFilterChange = (selectedTurnDate) => {
      setFilter({ ...filter, turnDate: selectedTurnDate });
   };

   const columns = [
      {
        name: "Turno",
        selector: "description",
        maxWidth: "200px",
        sortable: true
      },
      {
        name: "Horário",
        maxWidth: "200px",
        selector: "starts_at",
        format: (row) => `${moment(row.starts_at, "HH:mm:ss").format("HH:mm")} ~ ${moment(row.ends_at, "HH:mm:ss").format("HH:mm")}`,
        sortable: true,
      },
      {
        name: "Período",
        maxWidth: "200px",
        cell: (row) =>
          `${prettyDate(row.start_date)} ${
            row.end_date ? " a " + prettyDate(row.end_date) : " em diante"
          }`,
        sortable: true,
      },
      {
         name: "Capacidade (nº cotas)",
         maxWidth: "250px",
         selector: "capacity",
         sortable: true,
      },
      {
         name: "Tolerância",
         maxWidth: "150px",
         selector: "delay_max",
         format: (row) => moment(row.delay_max, "HH:mm:ss").format("HH:mm"),
         sortable: true,
      },
      {
         name: "Editar",
         maxWidth: "30px",
         cell: (row) => <ConfigButton {...row} />,
      },
      {
         name: "Excluir",
         maxWidth: "30px",
         cell: (row) => <DeleteButton {...row} />,
      },
   ];

   const noDataMessage = () => {
      if (!filter.turn_branch && !getDataStorageBranch()) {
         return "Por favor, selecione uma filial.";
      }
      if (!filter.turnDate && !getDataStorageTurnDate()) {
         return "Por favor, selecione uma data.";
      }
      return "Não existem dados a serem apresentados.";
   };


  const handleOnChange = (funcChange, valueStorage, nameStorage) => {
    funcChange(valueStorage)
    if (valueStorage !== null) {
      setDataStorage(nameStorage, valueStorage)
    } else {
      removeDataStorage(nameStorage);
    }
  }

  const handleCheckBox = () => {
     if (!showAvailableTurn) {
        setFilter({
           ...filter,
           turnDate: dateSelected
        });
        setDataStorage('turn_config_selectedTurnDate', dateSelected)
     }
      setAvailableTurn(!showAvailableTurn);
  }

  const isAddDisabled = () => {
     const intervalDate = moment(dateSelected).diff(moment(), 'days');
     return !(getDataStorageBranch() && dateSelected) || intervalDate < 0 || showAvailableTurn;
  }

   const [dateSelected, setDateSelected] = useState(getDataStorageTurnDate())

   return (
      <>
         <TabNavigationCtrlFilterPanel
            data-cy="turn-filter-panel"
            id="turn-filter-panel"
            headerFilter={
              <>
               <Grid className={classes.filters}>
                  <Grid className={classes.branchFilter}>
                     <Selector
                        options={branches}
                        isClearable
                        placeholder="Filtrar por filial"
                        data-cy="branch-filter"
                        id="branch-filter"
                        search
                        value={getDataStorageBranch()}
                        selected={getDataStorageBranch()?.value} // currently component performs clearValue in case value undefined
                        onChange={(selectedBranch) => {
                          if (selectedBranch) {
                            setViewCheckbox(true)
                            setAvailableTurn(false)
                          }

                          if (selectedBranch === null) {
                            setViewCheckbox(false)
                            setAvailableTurn(false)
                          }

                          handleOnChange(
                            handleBranchFilterChange,
                            selectedBranch,
                            'turn_config_checkSingleBranch'
                          )
                        }}
                     />
                  </Grid>
                  <Grid className={classes.dateFilter}>
                     <DateSelector
                        disabled={showAvailableTurn}
                        style={{height:30}}
                        data-cy="branch-date-filter"
                        id="branch-date-filter"
                        selected={showAvailableTurn ? null : dateSelected}
                        placeholder="Filtrar por Data"
                        onChange={(selectedTurnDate) => {
                           setDateSelected(selectedTurnDate)
                           handleOnChange(
                              handleTurnDateFilterChange,
                              selectedTurnDate,
                              'turn_config_selectedTurnDate'
                           );
                        }}
                     />
                    {
                      viewCheckbox &&
                      <div className={classes.checkBox}>
                        <Checkbox
                          checked={showAvailableTurn}
                          name="checkedA"
                          color="primary"
                          data-cy="show-all-configs"
                          id="show-all-configs"
                          onChange={handleCheckBox}
                        />
                        <label>
                          Mostrar todos os turnos configurados
                        </label>
                      </div>
                    }
                  </Grid>
               </Grid>

               </>

            }
            controlAreaClassName={classes.controlAreaClass}
            controlArea={
               <Button
                  color="primary"
                  variant="contained"
                  data-cy="add-turn-button"
                  id="add-turn-button"
                  autoFocus
                  size="large"
                  disabled={isAddDisabled()}
                  className={classes.addButton}
                  onClick={() => handleAddTurn()}
               >
                  Adicionar Turno
          </Button>
            }
            subRoutes={subRoutes}
         >
            <DefaultDataTable
               data-cy="turn-table"
               id="turn-table"
               columns={columns}
               data={(!(getTurnDate()) && !showAvailableTurn) ? [] : blocks}
               noDataMessage={noDataMessage()}
            />
         </TabNavigationCtrlFilterPanel>
         <Confirm
            isOpen={!!deletingItem}
            title="Confirmar exclusão?"
            message="Deseja excluir esse item da sua lista de turnos?"
            okText="Sim"
            data-cy="remove-modal"
            id="remove-modal"
            cancelText="Não"
            handleClose={handleModalDeleteClose}
         />
         <ModalData
            open={isOpenAddForm}
            editedData={editingItem}
            data-cy="edit-modal"
            id="edit-modal"
            filter={parseISO(getDataStorageTurnDate())}
            handleSave={handleSaveData}
            handleClose={handleCloseDataModal}
         />
         <ModalDeleteRefuse
            data={turnError}
            data-cy="delete-refuse-modal"
            id="delete-refuse-modal"
            isOpen={!!turnError}
            closeReadingNotificationDialog={() => {
               clearError(null);
               getNotificationsFromSchedConfigAsync();
            }}
         />
      </>
   );
};

TurnTabComponent.propTypes = {
   blocks: PropTypes.array.isRequired,
   branches: PropTypes.array.isRequired,
   filter: PropTypes.object.isRequired,
   setFilter: PropTypes.func.isRequired,
   subRoutes: PropTypes.array.isRequired,
   onDeleteItem: PropTypes.func.isRequired,
   onAddItem: PropTypes.func.isRequired,
   onUpdateItem: PropTypes.func.isRequired,
   getNotificationsFromSchedConfigAsync: PropTypes.func.isRequired
};

export default TurnTabComponent;
